
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PasswordInput extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: true }) value!: string;
  @Prop({ default: 'password' }) name!: string;
  @Prop({ default: 'current-password' }) autocomplete!: string;

  isVisible = false;

  toggleVisibility(): void {
    this.isVisible = !this.isVisible;
  }
}
